var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.68998 2.14478C5.08278 2.14478 2.14453 5.08303 2.14453 8.69023C2.14453 12.2974 5.08278 15.2357 8.68998 15.2357C10.2586 15.2357 11.6992 14.6787 12.8282 13.754L16.7363 17.6621C16.7966 17.7249 16.8688 17.7751 16.9488 17.8096C17.0287 17.8442 17.1148 17.8624 17.2018 17.8633C17.2889 17.8642 17.3753 17.8477 17.4559 17.8148C17.5365 17.7819 17.6098 17.7332 17.6714 17.6716C17.733 17.61 17.7816 17.5368 17.8145 17.4562C17.8475 17.3755 17.864 17.2892 17.8631 17.2021C17.8622 17.115 17.8439 17.029 17.8094 16.949C17.7748 16.8691 17.7247 16.7968 17.6619 16.7365L13.7538 12.8284C14.6784 11.6994 15.2354 10.2589 15.2354 8.69023C15.2354 5.08303 12.2972 2.14478 8.68998 2.14478ZM8.68998 3.45387C11.5897 3.45387 13.9263 5.79051 13.9263 8.69023C13.9263 11.5899 11.5897 13.9266 8.68998 13.9266C5.79027 13.9266 3.45362 11.5899 3.45362 8.69023C3.45362 5.79051 5.79027 3.45387 8.68998 3.45387Z",
    fill: "#4A5056"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/Magnifier.01645aabf31b4ace87a34442fe23141f.svg";
export { ForwardRef as ReactComponent };